import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import * as Actions from './actions';

export default handleActions(
    {
        [Actions.fetchAllSuccess.type]: (state, {payload}) => {
            return Map(payload.tags.map(tag => [tag.tagId, tag]));
        },
        [Actions.star.type]: (state, {payload: {tagId}}) => state.updateIn([tagId], tag => tag.set('starring', true)),
        [Actions.starSuccess.type]: (state, {payload: {tagId}}) =>
            state.updateIn([tagId], tag => tag.merge({starring: false, starred: true})),
        [Actions.starFailed.type]: (state, {payload: {tagId}}) =>
            state.updateIn([tagId], tag => tag.set('starring', false)),
        [Actions.unStar.type]: (state, {payload: {tagId}}) => state.updateIn([tagId], tag => tag.set('starring', true)),
        [Actions.unStarSuccess.type]: (state, {payload: {tagId}}) =>
            state.updateIn([tagId], tag => tag.merge({starring: false, starred: false})),
        [Actions.unStarFailed.type]: (state, {payload: {tagId}}) =>
            state.updateIn([tagId], tag => tag.set('starring', false)),
        [Actions.insert.type]: (state, {payload: {tag}}) => state.set(tag.tagId, tag),
    },
    Map(),
);
